import { Box, Flex } from '@chakra-ui/react';

import { TextMedium, TextRegular } from 'UiKit/typography';
import { LocationIcon } from 'Asset/icon';

import styles from './styles.module.css';

const DEFAULT_AREA_COLOR = '#FFEA8480';

const BadgeArea = ({ studioData }) => {
  const { room, studio, area } = studioData;
  const bgColor = area?.color || DEFAULT_AREA_COLOR;
  return (
    <Flex className={styles['location']}>
      <LocationIcon size="14px" color="var(--color-neutral60)" className={styles['location__icon']} />
      <Box>
        <TextMedium className={styles['location__room']}>{room}</TextMedium>
        <Flex className={styles['location__studio-row']}>
          <TextRegular className={styles['location__studio']}>{studio}</TextRegular>
          <Box className={styles['location__area-badge']} bg={bgColor}>
            <TextRegular className={styles['location__area-text']}>{area?.name}</TextRegular>
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default BadgeArea;
